var map = {
	"./00000000_陶猪/main.JPG": 13217,
	"./00000001_金面罩/main.JPG": 5400,
	"./00000002_金面具/main.JPG": 80395,
	"./00000003_青铜人头像/main.JPG": 2981,
	"./00000004_青铜顶尊人头像/main.JPG": 64836,
	"./00000005_玉樟/main.JPG": 49512,
	"./00000006_青铜神兽器盖/main.JPG": 30790,
	"./00000007_戴金面罩青铜人头像/main.JPG": 36911,
	"./00000008_戴金面罩青铜人头像/main.JPG": 98834,
	"./00000009_金杖/main.JPG": 29219,
	"./00000010_金面具/main.JPG": 5864,
	"./00000011_金面罩/main.JPG": 95721,
	"./00000012_戴金面罩青铜人头像/main.JPG": 83481,
	"./00000013_青铜人头像/main.JPG": 97992,
	"./00000014_青铜人头像/main.JPG": 6833,
	"./00000015_青铜人头像/main.JPG": 20418,
	"./00000016_青铜人头像/main.JPG": 34699,
	"./00000017_青铜人头像/main.JPG": 15092,
	"./00000018_青铜人头像/main.JPG": 77885,
	"./00000019_青铜人头像/main.JPG": 52414,
	"./00000020_青铜人头像/main.JPG": 72414,
	"./00000021_青铜人头像/main.JPG": 41725,
	"./00000022_陶人/main.JPG": 68409,
	"./00000023_陶三足炊器/main.JPG": 94438,
	"./00000024_陶高柄豆/main.JPG": 55115,
	"./00000025_陶盉/main.JPG": 88023,
	"./00000026_陶鸟头勺把/main.JPG": 88772,
	"./00000027_青铜着裙立人像/main.JPG": 50283,
	"./00000028_三孔玉壁形器/main.JPG": 6086,
	"./00000029_玉刀/main.JPG": 11335,
	"./00000030_青铜持鸟立人像/main.JPG": 73634,
	"./00000031_青铜扭头跪坐人像/main.JPG": 43071,
	"./00000032_金鸟形饰/main.JPG": 22592,
	"./00000033_青铜人身形牌饰/main.JPG": 8614,
	"./00000034_青铜人面像/main.JPG": 81093,
	"./00000045_青铜大立人像/main.JPG": 92595,
	"./00000046_青铜持璋小人像/main.JPG": 17447,
	"./00000047_祭山图玉璋/main.JPG": 36420,
	"./00000048_玉璋/main.JPG": 79881,
	"./00000049_玉戈/main.JPG": 17229,
	"./00000050_玉戈/main.JPG": 10995,
	"./00000051_青铜尊/main.JPG": 45807,
	"./00000052_青铜顶尊跪坐人像/main.JPG": 88395,
	"./00000053_青铜神兽/main.JPG": 73050,
	"./00000054_青铜兽首冠人像/main.JPG": 60608,
	"./00000055_青铜神兽/main.JPG": 44244,
	"./00000056_青铜尊/main.JPG": 17930,
	"./00000057_青铜神坛（残件）/main.JPG": 83552,
	"./00000058_青铜神坛底座/main.JPG": 7883,
	"./00000059_青铜神兽/main.JPG": 87648,
	"./00000060_青铜神坛顶部/main.JPG": 23104,
	"./00000061_青铜戴尖脊帽小立人像/main.JPG": 43834,
	"./00000062_青铜戴尖脊帽小立人像/main.JPG": 79501,
	"./00000063_青铜纵目面具/main.JPG": 17182,
	"./00000064_青铜纵目面具/main.JPG": 77513,
	"./00000065_青铜大面具/main.JPG": 29728,
	"./00000066_青铜眼形器/main.JPG": 91537,
	"./00000067_青铜兽面/main.JPG": 4605,
	"./00000068_青铜面具/main.JPG": 53974,
	"./00000069_青铜面具/main.JPG": 53667,
	"./00000070_青铜面具/main.JPG": 63917,
	"./00000071_青铜面具/main.JPG": 10224,
	"./00000072_青铜鸟足曲身顶尊神像/main.JPG": 27078,
	"./00000073_青铜持龙杖形器立人像/main.JPG": 80625,
	"./00000075_青铜爬龙器盖/main.JPG": 97534,
	"./00000076_青铜龙柱形器/main.JPG": 49020,
	"./00000077_青铜虎形兽/main.JPG": 39454,
	"./00000078_青铜虎头龙身像/main.JPG": 70903,
	"./00000079_青铜虎/main.JPG": 29781,
	"./00000080_青铜蛇/main.JPG": 69366,
	"./00000090_青铜龙形器/main.JPG": 47583,
	"./00000091_青铜太阳形器/main.JPG": 42668,
	"./00000092_青铜大鸟头/main.JPG": 45586,
	"./00000093_青铜凤鸟柱头/main.JPG": 79811,
	"./00000094_青铜鸡/main.JPG": 86249,
	"./00000095_三号青铜神树/main.JPG": 3416,
	"./00000096_一号青铜神树/main.JPG": 33638,
	"./00000097_二号青铜神树/main.JPG": 46467,
	"./00000098_青铜凤鸟/main.JPG": 49429,
	"./00000099_神树纹玉琮/main.JPG": 364
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 37516;